module.exports = __webpack_public_path__ + "static/media/paint-bucket-white.2b0f3b7d.svg";